import { Command } from 'commands/Commands';

export class ChangeAddressPostcode extends Command {
  type: string = 'ChangeAddressPostcode';
  priority: number = 100;
}
